"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// 是否weex
exports.isWeex = function () {
    return typeof callNative === 'function' || (typeof WXEnvironment === 'object' && WXEnvironment.platform !== 'Web');
};
// 是否微信小程序(仅验证UNI-APP框架)
exports.isWxMp = function () {
    return (typeof process === 'object' &&
        typeof process.env &&
        (process.env.PLATFORM === 'mp' || process.env.VUE_APP_PLATFORM === 'mp-weixin'));
};
